function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? Object(arguments[r]) : {}, o = Object.keys(t); "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) { return Object.getOwnPropertyDescriptor(t, e).enumerable; })), o.forEach(function (r) { _defineProperty(e, r, t[r]); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useRef, useEffect, useState, forwardRef, useContext } from 'react';
import styles from './InlineActionPopup.module.scss';
import { injectIntl } from 'react-intl';
import useConfineTabbing from '../hooks/useConfineTabbing';
import tabbable from 'tabbable';
import { formatI18n } from '../I18n/I18n/I18n';
import ClientColorCss from '../ClientColorCss/ClientColorCss';
import ThemeContext from '../ThemeContext';
var PopupWithRef = forwardRef(Popup);
function InlineActionPopup(_ref) {
  var children = _ref.children,
    _ref$rect = _ref.rect,
    rect = _ref$rect === void 0 ? {} : _ref$rect,
    _ref$show = _ref.show,
    show = _ref$show === void 0 ? false : _ref$show,
    label = _ref.label,
    intl = _ref.intl,
    attrs = _objectWithoutProperties(_ref, ["children", "rect", "show", "label", "intl"]);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    calculating = _useState2[0],
    setCalculating = _useState2[1];
  var _useState3 = useState({
      height: 0,
      width: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    _useState4$ = _useState4[0],
    height = _useState4$.height,
    width = _useState4$.width,
    setWidth = _useState4[1];
  var formattedLabel = formatI18n(intl, label);
  var calcRef = useRef(null);
  useEffect(function () {
    if (calcRef.current) {
      var _calcRef$current$getB = calcRef.current.getBoundingClientRect(),
        _height = _calcRef$current$getB.height,
        _width = _calcRef$current$getB.width;
      setWidth({
        height: _height,
        width: _width
      });
      setCalculating(false);
    }
  }, []);
  if (calculating) {
    return /*#__PURE__*/React.createElement(PopupWithRef, {
      ref: calcRef,
      label: formattedLabel,
      style: {
        visibility: 'hidden',
        left: '-9999px'
      }
    }, children);
  } else if (show && rect.top) {
    var top = calculateTop(rect.top, rect.height, height);
    var left = calculateLeft(rect.left, rect.width, width, window.innerWidth);
    return /*#__PURE__*/React.createElement(PopupWithRef, Object.assign({
      label: formattedLabel,
      top: top,
      left: left
    }, attrs), children);
  } else {
    return null;
  }
}
export default injectIntl(InlineActionPopup);
function calculateTop(rectTop, rectHeight, actionHeight) {
  if (rectTop > actionHeight) {
    return rectTop - actionHeight;
  } else {
    return rectTop + rectHeight;
  }
}
function calculateLeft(rectLeft, rectWidth, actionWidth, windowWidth) {
  var left = Math.max(0, rectLeft + rectWidth / 2 - actionWidth / 2);
  if (left + actionWidth > windowWidth) {
    return windowWidth - actionWidth;
  } else {
    return left;
  }
}
function Popup(_ref2, ref) {
  var label = _ref2.label,
    children = _ref2.children,
    left = _ref2.left,
    top = _ref2.top,
    style = _ref2.style,
    attrs = _objectWithoutProperties(_ref2, ["label", "children", "left", "top", "style"]);
  var theme = useContext(ThemeContext);
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    tabbingRef = _useState6[0],
    setRef = _useState6[1];
  useConfineTabbing(tabbingRef);
  useEffect(function () {
    if (!ref && tabbingRef) {
      var _tabbable = tabbable(tabbingRef),
        _tabbable2 = _slicedToArray(_tabbable, 1),
        firstTabbable = _tabbable2[0];
      firstTabbable && firstTabbable.focus();
    }
  }, [ref, tabbingRef]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, theme !== 'ripple' && /*#__PURE__*/React.createElement(ClientColorCss, {
    id: "inline-action-popup"
  }, function (_ref3) {
    var trimColorPrimary = _ref3.trimColorPrimary;
    return ".".concat(styles.popup, " { background-color: ").concat(trimColorPrimary, "; }");
  }), /*#__PURE__*/React.createElement("div", Object.assign({}, attrs, {
    ref: ref || setRef,
    role: "dialog",
    "aria-label": label,
    className: styles.popup,
    style: _objectSpread({}, style, {
      top: top || 0,
      left: left || 0
    })
  }), children));
}